export default "__VITE_ASSET__Riy6hxwq__"